import "./App.css";
import "react-bootstrap";
import React from "react";
import Navigation from "./authentication/Navigation";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./authentication/firebase";
import Home from "./menu/Home";
import Vendors from "./menu/Vendors";
import Register from "./menu/Register";
import FooterComponent from "./reusable-comps/footer";
import Admin from "./menu/Admin";
import Connect from "./menu/Connect";
import EditVendor from "./menu/EditVendor";
import AuthPage from "./authentication/AuthPage";
import Followers from "./menu/Followers";
import Categories from "./menu/Categories";
import CategoryDescription from "./menu/CategoryDescription";
import MobileBar from "./authentication/MobileBar";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <ThemeProvider>
        <div className="App vh-100 manrope-dugam d-flex align-items-center justify-content-center">
          <div
            className="spinner-border"
            role="status"
            style={{ color: "var(--accent)" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App vh-100 manrope-dugam">
          {user && <Navigation />}

          <Routes>
            {user ? (
              <>
                <Route path="/" element={<Home user={user} />} />
                <Route path="/home" element={<Home user={user} />} />
                <Route path="/register" element={<Register user={user} />} />
                <Route path="/vendors" element={<Vendors user={user} />} />
                <Route path="/connect" element={<Connect user={user} />} />
                <Route
                  path="/categories"
                  element={<Categories user={user} />}
                />
                <Route
                  path="/view-categories"
                  element={<CategoryDescription user={user} />}
                />
                <Route path="/admin/*" element={<Admin user={user} />} />
                <Route
                  path="/account-follow"
                  element={<Followers user={user} />}
                />
                <Route
                  path="/edit-vendor/:ID"
                  element={<EditVendor user={user} />}
                />
                {/* Redirect auth pages to home if already logged in */}
                <Route path="/login" element={<Navigate to="/home" replace />} />
                <Route path="/signup" element={<Navigate to="/home" replace />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/signup" element={<AuthPage />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </>
            )}
          </Routes>

          {user && <FooterComponent />}
          {user && <MobileBar />}
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
